export default (value) => (typeof value === 'string' ? value.trim() : value);
